<template>
  <v-card :loading="loading" :disabled="internalDisabled" v-bind="$attrs">
    <div>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{
            $t('fresh-vue-cards.ProcessFlowCard.title')
          }}</v-list-item-title>
          <v-list-item-subtitle v-if="flowItems?.length > 0">
            {{
              $t('fresh-vue-cards.ProcessFlowCard.progress', {
                current: numberOfCompletedItems,
                max: numberOfRequiredItems
              })
            }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action v-if="flowItems?.length > 0">
          <v-progress-circular
            color="primary"
            class="ml-2"
            :value="completionPercentage"
            :rotate="-90"
            size="50"
          >
            <span class="font-weight-bold">{{ completionPercentage }}%</span>
          </v-progress-circular>
        </v-list-item-action>
      </v-list-item>
    </div>

    <v-treeview
      v-if="flowItems?.length > 0"
      dense
      open-all
      :open-on-click="selectable"
      :activatable="selectable"
      transition
      :items="flowItems"
      :active.sync="active"
    >
      <template #prepend="{ item }">
        <div class="mr-2">
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
          <v-icon v-else-if="item.completed" color="success">
            $freshvuecard-process-completed
          </v-icon>
          <!-- <v-icon v-else-if="item.required" color="error">$freshvuecard-process-missing</v-icon> -->
          <v-icon v-else>$freshvuecard-process-uncompleted</v-icon>
        </div>
      </template>

      <template #label="{ item }">
        {{ item.name }}

        <v-scale-transition>
          <v-chip
            v-if="item.info"
            color="info"
            class="ml-2"
            x-small
            label
            :outlined="item.disabled"
          >
            {{ item.info }}
          </v-chip>
        </v-scale-transition>

        <v-scale-transition>
          <v-chip
            v-if="item.required && !item.completed"
            color="error"
            class="ml-2"
            x-small
            label
          >
            {{ $t('fresh-vue-cards.misc.missing') }}
          </v-chip>
        </v-scale-transition>
      </template>
    </v-treeview>
    <div v-else class="text-center caption">
      {{ $t('fresh-vue-cards.misc.no-steps') }}
    </div>
  </v-card>
</template>

<script>
import { ArrayUtils } from '@freshsolutions/fresh-vue'

export default {
  name: 'ProcessFlowCard',

  components: {},

  props: {
    value: {
      type: String,
      required: false,
      default: null
    },

    flowItems: {
      type: Array,
      required: false,
      default: null
    },

    selectable: {
      type: Boolean,
      required: false,
      default: false
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      active: []
    }
  },

  computed: {
    numberOfAllItems() {
      return this.countItems(this.flowItems)
    },

    numberOfCompletedItems() {
      return this.countItems(
        this.flowItems,
        (item) => item.required && item.completed
      )
    },

    numberOfRequiredItems() {
      return this.countItems(this.flowItems, (item) => item.required)
    },

    completionPercentage() {
      return parseInt(
        (this.numberOfCompletedItems / this.numberOfRequiredItems) * 100
      )
    },

    internalDisabled() {
      return this.disabled || this.loading
    }
  },

  watch: {
    value: {
      handler(value) {
        if (value) {
          this.active = [value]
        } else {
          this.active = []
        }
      },
      immediate: true
    },

    active(active) {
      this.$emit('input', active[0] ?? null)
    }
  },

  methods: {
    countItems(items, filter) {
      return ArrayUtils.countItemsRecursive(items, filter, 'children')
    }
  }
}
</script>
